export const getClassroomInfo = (courseData, currentSubsectionID) => {
  const { courseTitle, sections } = courseData;

  let sectionNumber, subSectionNumber;
  sections.forEach(({ subSections }, sectionIndex) => {
    subSections.forEach(({ id }, subsectionIndex) => {
      if (id === currentSubsectionID) {
        sectionNumber = sectionIndex + 1;
        subSectionNumber = subsectionIndex + 1;
        return;
      }
    });
  });

  const courseTitleKebabCase = courseTitle.split(' ').join('-').toLowerCase();

  return { courseTitle: courseTitleKebabCase, sectionNumber, subSectionNumber };
};

/**
 * @param {object} courseData
 * @param {string} currentSubsectionID
 * @param {{ title: string; value: string|number }[]} additionalData
 */
export function getEventLabel(courseData, currentSubsectionID, ...additionalData) {
  const { courseTitle, sectionNumber, subSectionNumber } = getClassroomInfo(
    courseData,
    currentSubsectionID
  );

  const label = `Course:${courseTitle}|Section:${sectionNumber}|Subsection:${subSectionNumber}`;

  const additionalLabel = additionalData.map((datum) => `|${datum.title}:${datum.value}`).join('');

  return `${label}${additionalLabel}`;
}
